import React from "react";
import { motion } from "framer-motion";

export default function PurpleSmoke() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden>
      <motion.div
        className="absolute -top-40 left-1/2 -translate-x-1/2 h-[1100px] w-[1100px] rounded-full"
        style={{ background: "radial-gradient(circle at 50% 45%, rgba(139,92,246,0.32) 0%, rgba(76,29,149,0.18) 30%, rgba(10,10,15,0) 65%)", filter: "blur(20px)" }}
        animate={{ scale: [1, 1.05, 1], opacity: [0.85, 1, 0.85] }}
        transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-[20%] left-[8%] h-[520px] w-[520px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(124,58,237,0.20) 0%, rgba(76,29,149,0.0) 70%)", filter: "blur(40px)" }}
        animate={{ x: [0, 60, 0], y: [0, -30, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-[12%] right-[6%] h-[620px] w-[620px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(168,85,247,0.18) 0%, rgba(76,29,149,0.0) 70%)", filter: "blur(50px)" }}
        animate={{ x: [0, -50, 0], y: [0, 40, 0] }}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-10%,rgba(0,0,0,0)_0%,rgba(10,10,15,0.8)_70%)]" />
    </div>
  );
}
